import FreeResponseInputs from "pages/QuestionPage/questionCreation/FreeResponseInputs/FreeResponseInputs";

export default FreeResponseInputs;
